export default __webpack_public_path__ + "static/media/simple2.d555cedd.png";